<template>
  <span class="insights-ia-badge" :class="defineClass">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { InsightsIABadgeVariant } from "./InsightsBagdeTypes";

const props = withDefaults(
  defineProps<{
    label: string;
    variant?: InsightsIABadgeVariant;
  }>(),
  {
    variant: InsightsIABadgeVariant.Primary
  }
);

const defineClass = computed(() => {
  return {
    "insights-ia-badge--primary":
      props.variant === InsightsIABadgeVariant.Primary,
    "insights-ia-badge--success":
      props.variant === InsightsIABadgeVariant.Success,
    "insights-ia-badge--critical":
      props.variant === InsightsIABadgeVariant.Critical,
    "insights-ia-badge--warning":
      props.variant === InsightsIABadgeVariant.Warning,
    "insights-ia-badge--infos": props.variant === InsightsIABadgeVariant.Infos
  };
});
</script>

<style scoped lang="scss">
.insights-ia-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0 4px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  font-family: $fontFamily;

  &--primary,
  &--infos {
    background: _map.get($map: $azulPrincipal, $key: 100);
    color: _map.get($map: $azulPrincipal, $key: 700);
    font-weight: 600;
  }

  &--success {
    background: _map.get($map: $verde, $key: 50);
    color: _map.get($map: $verde, $key: 800);
    font-weight: 600;
  }

  &--critical {
    background: _map.get($map: $vermelho, $key: 50);
    color: _map.get($map: $vermelho, $key: 800);
    font-weight: 600;
  }

  &--warning {
    background: _map.get($map: $laranja, $key: 100);
    color: _map.get($map: $laranja, $key: 800);
    font-weight: 600;
  }
}
</style>
